/**
 * Stand und Schalter der Datenschutzerklärung (/datenschutz, Roadmap KA-22).
 *
 * WARUM feste Werte im Code und nicht die App-Schalter aus `app_feature_flags`:
 * - Die Seite ist öffentlich. `app_feature_flags` lesen nur Support-Mitarbeitende (RLS),
 *   `app_my_features` antwortet nur für eingeloggte Kundinnen und Kunden. Anonyme Besucher,
 *   Store-Prüfer und Suchmaschinen würden immer „aus“ sehen.
 * - Ein Rechtstext muss für alle gleich und nachvollziehbar sein: Jede Fassung hat ein
 *   Datum („Stand“) und liegt in der Git-Historie. Ein Text, der sich still mit einem
 *   Schalter im Admin ändert, hätte weder das eine noch das andere.
 * - Ein Schalter auf „Pilot“ verarbeitet schon echte Daten. Der Abschnitt muss also VOR
 *   dem Pilot sichtbar sein, nicht erst bei „an“.
 *
 * ABLAUF, wenn eine Funktion startet (push, live_activity, haushalt):
 *   1. Hier den Wert auf true setzen und DATENSCHUTZ_STAND auf das Veröffentlichungsdatum.
 *   2. PR mergen und per Lovable veröffentlichen.
 *   3. Erst danach den Schalter im Admin auf „Pilot“ oder „an“ stellen.
 *
 * Reine Datei: keine Imports, kein React, kein Datum zur Laufzeit.
 */

/** Wird auf der Seite als „Stand“ gezeigt. Beim Veröffentlichen jeder neuen Fassung anpassen. */
export const DATENSCHUTZ_STAND = "27. Oktober 2026";

/** Maschinenlesbar für Helmet/JSON-LD (dateModified). Muss zu DATENSCHUTZ_STAND passen. */
export const DATENSCHUTZ_STAND_ISO = "2026-10-27";

/**
 * Abschnitte zu App-Funktionen, die gebaut, aber noch nicht gestartet sind.
 * Stand 08.10.2026 live: push = off, live_activity = off, haushalt = off.
 */
export const DATENSCHUTZ_APP_FUNKTIONEN = {
  /** Abschnitt 10 „Push-Benachrichtigungen“ und Zeile „Push-Tokens“ in Abschnitt 20. */
  push: false,
  /** Abschnitt 10 „Anzeige auf dem Sperrbildschirm“ (Live Activity / laufende Benachrichtigung). */
  live_activity: false,
  /** Abschnitt 10 „Familie und Haushalt“. */
  haushalt: false,
  /**
   * Abschnitt 10 „Statistik in der App (Google Analytics for Firebase)“, die angepassten Sätze in
   * „Nutzungsmessung“ und „Kein Werbe-Tracking“, der Hinweis in Abschnitt 13 und die Zeile in Abschnitt 20.
   * Freigabe Noah 08.10.2026. An, weil der Code (charliescrew #831, charlies-app #11) zeitgleich gemergt wird.
   * Messen kann die App erst mit dem nächsten Store-Build mit Firebase, und nur nach Einwilligung.
   */
  statistik_firebase: true,
} as const;
